import { Component, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { CommonModule, NgFor, NgIf, NgOptimizedImage } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatDrawer, MatSidenavModule } from "@angular/material/sidenav";
import { Subject, Subscription, takeUntil } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import * as _moment from "moment";
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment, Moment } from "moment";
import { DynamicSettingsService } from "app/layout/common/dynamic-settings/dynamic-settings.service";
import { ModalComponent } from "app/modules/shared/modal.component";
import { ModalService } from "app/_services/modal.service";
import { DynamicFormComponent } from "app/modules/shared/forms/dynamic-form/dynamic-form.component";
import { FuseConfirmationService } from "@fuse/services/confirmation";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UserService } from "app/core/user/user.service";
import { fuseAnimations } from "@fuse/animations";
import { cloneDeep } from "lodash";
import { KeyPairsComponent } from "app/modules/shared/key-pairs/key-pairs.component";
import { GridsComponent } from "app/modules/shared/grids/grids.component";
import { TableComponent } from "app/modules/shared/table/table.component";
import { FuseScrollbarDirective } from "@fuse/directives/scrollbar";
import { MaterialModule } from "app/material.module";
import { AppFilterPipeModule } from "app/_filters/app.filter-pipe.module";
import { FuseAlertComponent } from "@fuse/components/alert";
import { CommonService } from "app/_services/common.service";
import { LoaderService } from "app/_services/loader.service";
import { BaseRequestService } from "app/_services/base.service";
import { MyToastrService } from "app/_services/toastr.service";

const moment = _rollupMoment || _moment;


@Component({
  selector: 'app-domain-details',
  standalone: true,
  imports: [CommonModule,
    GridsComponent,
    KeyPairsComponent,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    ModalComponent,
    TableComponent,
    FuseScrollbarDirective,
    MaterialModule,
    AppFilterPipeModule,
    DynamicFormComponent,
    FuseAlertComponent,
    NgIf,
    NgFor,
    ReactiveFormsModule,
    FormsModule,],
  templateUrl: './domain-details.component.html',
  styleUrls: ['./domain-details.component.scss']
})
export class DomainDetailsComponent {
  allDomainTableOptions: any = {};
  @Input() details: any = {};
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  constructor(
    private cs: CommonService,
    private loaderService: LoaderService,
    private route: ActivatedRoute,
    private _ds: DynamicSettingsService,
    private _bs: BaseRequestService,
    public _modalService: ModalService,
    public _userService: UserService,
    private toast: MyToastrService,
    public confirmDialog: FuseConfirmationService,
  ) {
  }
  ngOnInit(): void {
    this.getTable();
  }

  getTable() {
    try {
      this.route.data.subscribe((v: any) => {
        this.allDomainTableOptions = {
          columns: [
            {
              header: "First Name",
              columnDef: "first_name",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.first_name}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Last Name",
              columnDef: "last_name",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.last_name}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Email",
              columnDef: "email",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.email}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Roles",
              columnDef: "roles",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.roles}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
          ],
          sortOptions: { active: "email", direction: "asc" },
          _pageData: [],
          tableOptions: {
            title: "User Details",
            isServerSide: false,
            selectText: "userDetails(s)",
            loading: true,
            floatingFilter: true,
            rowSelection: false,
            showAction: true,
            actionMenuItems: [
              {
                text: 'Delete User',
                icon: 'delete',
                callback: 'editFunction',
                hideLocal: false,
                isGlobal: false,
              },
              {
                text: 'Reset MFA',
                icon: 'edit',
                callback: 'editFunction',
                hideLocal: false,
                isGlobal: false,
              },
            ],
            pagination: true,
            pageOptions: [5, 10, 25, 100],
            pageSize: 10,
            search: false,
            saveData: true,
            showhideList: true,
            refreshData: true,
            showFilter: false,
            showTagFilter: false,
            exportExcel: false,
            add: false,
            columnSearch: false,
            compareData: false,
            filterDownload: false,
            // serverSide: false,
            serverSide: {
              url: "/r/partners/get_tenant_users",
              condition: `true`,
              // isGlobal: true,
              type: "post",
              params: { tenant_id: `${this.details.tenant_id}` },
            },

          },
          changeValue: new Subject<any>(),
        };
      });
    } catch (error) {
      console.error("Error retrieving route data:", error);
    }
  }
  actionCall($event: any): void {
    if ($event.action.text == 'Reset MFA') {
      this.resetMFA($event.row);
    }
    if ($event.action.text == 'Delete User') {
      this.deleteRecord($event.row);
    }
  }
  resetMFA(data: any) {
    let condition = {
      tenantid: this.details.tenant_id,
      user_email: data.email
    }
    const confirmation = this.confirmDialog.open({
      title: 'Confirmation',
      message: `Are you sure you want to Reset MFA ?`,
      actions: {
        confirm: {
          label: 'Yes'
        }
      }
    });
    confirmation.afterClosed().subscribe((result: any) => {
      if (result === 'confirmed') {
        this._bs.doRequest(`/w/partners/reset_mfa`, 'post', condition)
          .pipe(takeUntil(this._unsubscribeAll))
          .subscribe((result: any) => {
            if (result.status) {
              this.toast.sToast('success', 'Removed successfully');
              setTimeout(() => {
                this.allDomainTableOptions.changeValue.next(true);
              }, 3000);
            } else {
              const data = (result.message) ? result.message : result.data;
              this.toast.sToast('error', data);
            }
          });
      }
    })
  }
  deleteRecord(data: any) {
    let condition = {
      tenantid: this.details.tenant_id,
      user_email: data.email
    }
    const confirmation = this.confirmDialog.open({
      title: 'Confirmation',
      message: `Are you sure you want to delete user ?`,
      actions: {
        confirm: {
          label: 'Yes'
        }
      }
    });
    confirmation.afterClosed().subscribe((result: any) => {
      if (result === 'confirmed') {
        this._bs.doRequest(`/d/partners/delete_tenant_user`, 'delete', condition)
          .pipe(takeUntil(this._unsubscribeAll))
          .subscribe((result: any) => {
            if (result.status) {
              this.toast.sToast('success', 'Removed successfully');
              setTimeout(() => {
                this.allDomainTableOptions.changeValue.next(true);
              }, 3000);
            } else {
              const data = (result.message) ? result.message : result.data;
              this.toast.sToast('error', data);
            }
          });
      }
    })
  }
}
